import React from "react";
import "./Stats.css";

import {fMean,fStdDev,fMedian, fSkewness, fKurtosis, fQuantile,
  ordinal, nCDF, durbinWatson, calculateMAD} from "./StatFunctions.js";

const Stats = (props) => {

//  console.log(props)
  
  if(!props.data){
    return <div></div>;
  }

  const timeData = props.data.map((e)=>{return e.item})
  if(!timeData || timeData === false || timeData.length === 0){
    return <div></div>;
  }
  
  const currentTime = timeData[0];
  const timeDataSorted = [...timeData].sort((a, b) => a - b);

  const mean = fMean(timeData);
  const stdv = fStdDev(timeData);
  const cvar = ((100 * stdv) / mean).toFixed(0) + "%";
  const min = Math.min(...timeData);
  const max = Math.max(...timeData);
  const rnge = (max - min);
  const mid = fMedian(timeData);
  const skw = fSkewness(timeData);
  const kur = fKurtosis(timeData);
  const q1 = fQuantile(timeData, 0.25);
  const q3 = fQuantile(timeData, 0.75);
  const iqr = (q3 - q1);
  const outlier_lower = q1 - 1.5 * iqr
  const outlier_upper = q1 + 1.5 * iqr
  // const z = ((timeData[0] - mean) / stdv);
  const norm = parseInt(100*(1 - nCDF(timeData[0], mean, stdv)));
  const normord = ordinal(norm)
  const dwstat = durbinWatson(timeData.toReversed())

  // IDR = interdecile range, aka percentile range
  const idr = fQuantile(timeData, 0.90) - fQuantile(timeData, 0.10);

  const rank = timeDataSorted.indexOf(currentTime) + 1;
  const rankord = ordinal(rank)
  const last5 = timeData.slice(0,5)
  const rank5 = last5.sort((a,b)=>a-b).indexOf(currentTime)+1

  let rank5ord = ordinal(rank5)
  if(last5.length !== 5){
    rank5ord = "-"
  }


  const last12 = timeData.slice(0,12)
  const rank12 = last12.sort((a,b)=>a-b).indexOf(currentTime)+1
  let rank12ord = ordinal(rank12)
  if(last12.length !== 12){
    rank12ord = "-"
  }
  const mad = calculateMAD(timeData) // mean absolute deviation

  //const optimal_lag_order = parseInt(Math.sqrt(timeData.length))  // ref. https://www.numberanalytics.com/blog/ultimate-ljung-box-test-guide
  //const acf = autocorrelation(timeData.toReversed(),optimal_lag_order)

  const fmt = (x) =>{
    if(x > 0 && x < 60 ){
      return x.toFixed(2)
    }else{
      if(x === 999999){
        return "-"
      }else{
        return x.toFixed(1)
      }
    }
  }

  let confLower = mean - (1.96 * stdv) / Math.sqrt(timeData.length);
  let confUpper = +mean + (1.96 * stdv) / Math.sqrt(timeData.length);




  // // Optimize the smoothing constant 
  // let bestAlpha = .750;
  // if(timeData.length >= 5 && timeData.length % 5 == 0){
  //   let alpha = 0.01;
  //   let minRMSE = 9999;
  //   for(alpha = 0.01; alpha <= 0.99; alpha+=0.01){
  //     let x = timeData.toReversed()
  //     let y = simpleExponentialSmoothing(x, alpha);
  //     //console.log(x.length + " vs " + timeData.toReversed().length)
  //     let rmse = calculateRMSE(x.slice(1,x.length),  y.slice(0,y.length-1));
  //     if(rmse < minRMSE){
  //       minRMSE = rmse
  //       bestAlpha = alpha
  //     }
  //     // console.log(alpha + " : " + rmse.toFixed(4));
  //   }
  //   //setSmoothingAlpha(bestAlpha)
  //   console.log("optimal alpha: " + bestAlpha.toFixed(4) + " RMSE=" + minRMSE.toFixed(4))
  // }
  
  // let bestAlpha = findSESOptimalAlpha(timeData.toReversed());
  // let ses = simpleExponentialSmoothing(timeData.toReversed(), bestAlpha)
  // let forecast = ses[ses.length-1];
  // console.log("n=" + timeData.length + ", forecast: " + forecast.toFixed(2))


  // console.log(timeData.toReversed())
  // console.log(ses)
 
  // if(forecast <= 0){
  //   forecast = 0.75 * q1 //arbitrarily use 75% of the first quartile
  // }

  // const tma = props.data
  
  // if(tma.length >= 1){
  //   tma[0]["target"] = forecast;   //adds new key/value pair to the props object
  // }
  

  let outliers = 0;
  for(let i = 0; i < timeData.length; i++){
    let x = timeData[i];
    if(x < outlier_lower || x > outlier_upper){
      outliers += 1;
    }
  }


  const target = props.data[0].target;
  const alpha = props.data[0].optalpha.toFixed(3)

  // const vx = props.data.map((e)=>e.item);
  // let outliers = 0;
  // for (let i = 0; i < vx.length; i++){
  //   console.log(vx[i])
  //   if(vx[i].outlier === true){
  //     outliers += 1;
  //   }
  // }

  // let outliers = 0;
  // for(let i = 0; i < timeData.length; i++){
  //   let x = timeData[i];
  //   if(x < outlier_lower || x > outlier_upper){
  //     outliers += 1;
  //   }
  // }  


  return (
    <div className="stats-tables">
      <table className="stats-table">
        <tbody>
        <tr>
          <td className="stats-table-header">#{timeData.length}</td>
          <td className="stats-table-header" title="Rank of all solves">of all</td>
          <td className="stats-table-header" title="Rank of the last 5 solves">of 5</td>
          <td className="stats-table-header" title="Rank of the last 12 solves">of 12</td>
          <td className="stats-table-header"title="Percentile">&#37;tile</td>          
        </tr>
        <tr>
          <td className="stats-table-item">{fmt(currentTime)}</td>
          <td className="stats-table-item">{rankord}</td>
          <td className="stats-table-item">{rank5ord}</td>
          <td className="stats-table-item">{rank12ord}</td>
          <td className="stats-table-item">{normord}</td>          
        </tr>        

        <tr>
          <td className="stats-table-header" title="Average">Mean</td>
          <td className="stats-table-header" title="Standard deviation">StdDev</td>
          <td className="stats-table-header" title="Lower 95% confidence limit">LwrCL</td>
          <td className="stats-table-header" title="Upper 95% confidence limit">UprCL</td>
          <td className="stats-table-header" title="Coefficient of variation">CV</td>
        </tr>
        <tr>
          <td className="stats-table-item">{fmt(mean)}</td>
          <td className="stats-table-item">{fmt(stdv)}</td>
          <td className="stats-table-item" colSpan="1">{fmt(confLower)}</td>
          <td className="stats-table-item" colSpan="1">{fmt(confUpper)}</td>
          <td className="stats-table-item">{cvar}</td>

          

        </tr>

        <tr>
          <td className="stats-table-header">Median</td>
          <td className="stats-table-header">Min</td>
          <td className="stats-table-header">Q1</td>
          <td className="stats-table-header">Q3</td>
          
          <td className="stats-table-header">Max</td>
        </tr>
        <tr>
        <td className="stats-table-item">{fmt(mid)}</td>
        <td className="stats-table-item">{fmt(min)}</td>        
        <td className="stats-table-item">{fmt(q1)}</td>
        <td className="stats-table-item">{fmt(q3)}</td>
        <td className="stats-table-item">{fmt(max)}</td>
        </tr>



        <tr>
          <td className="stats-table-header">Range</td>
          <td className="stats-table-header">IDR</td>
          <td className="stats-table-header">IQR</td>  
          
          <td className="stats-table-header">MAD</td>
          <td className="stats-table-header">Outliers </td>
        </tr>
        <tr>
          <td className="stats-table-item">{fmt(rnge)}</td>
          <td className="stats-table-item">{fmt(idr)}</td>
          <td className="stats-table-item">{fmt(iqr)}</td>
          
          <td className="stats-table-item">{fmt(mad)}</td>
          <td className="stats-table-item">{outliers}</td>
        </tr>


        <tr>
          <td className="stats-table-header">Skw</td>
          <td className="stats-table-header">Kur</td>
          <td className="stats-table-header">DW</td>
          {/* <td className="stats-table-header">ACF{optimal_lag_order}</td> */}
          <td className="stats-table-header">SES&alpha;</td>
          
          <td className="stats-table-header">Target</td>
        </tr>
        <tr>
          
          <td className="stats-table-item">{skw.toFixed(2)}</td>
          <td className="stats-table-item">{fmt(kur)}</td>
          <td className="stats-table-item">{fmt(dwstat)}</td>
          {/* <td className="stats-table-item">{acf.toFixed(2)}</td> */}
          <td className="stats-table-item">{alpha}</td>
          <td className="stats-table-item">{fmt(target)}</td>
        </tr>


        </tbody>
      </table>
    </div>
  );
};

export default React.memo(Stats); //memo prevents this component from running every time
